// Cada tela é baixada só ao abrir a rota. Depois da entrada, este módulo baixa as demais em segundo plano:
// sem internet, abrir uma tela ainda não visitada continua funcionando (antes a página ficava em branco).
const telas = import.meta.glob(["../paginas/*.tsx", "!../paginas/Outras.tsx", "!../paginas/Entrada.tsx"]);

export const preCarregarTelas = () => Promise.allSettled(Object.values(telas).map((carregar) => carregar()));
